import { forwardRef, useMemo } from 'react';
import type { StackProps } from './helpers';
import { createClickableProps, omitStackProps, useStackStyles } from './helpers';

/**
 * XStack is a horizontal stack component that allows for easy layouts with row direction
 */
export const XStack = forwardRef<HTMLDivElement, StackProps>((props, ref) => {
  const { children, reversed, testId } = props;
  const { classes, style } = useStackStyles(props, reversed ? 'rowReverse' : 'row');
  const memoizedRestProps = useMemo(() => omitStackProps(props), [props]);
  const clickableProps = props.onClick ? createClickableProps(props, classes, style) : undefined;

  if (clickableProps) {
    return (
      <div {...clickableProps} data-testid={testId} ref={ref} {...memoizedRestProps}>
        {children}
      </div>
    );
  }

  return (
    <div className={classes} data-testid={testId} ref={ref} {...memoizedRestProps}>
      {children}
    </div>
  );
});
